import MaterialIconsTTF from "../assets/fonts/icons/material-icons-regular.ttf"

import DMSansWoff2 from "../assets/fonts/dm-sans/DMSans-Regular.woff2"
import DMSansLatinExtWoff2 from "../assets/fonts/dm-sans/DMSans-Latin-Ext.woff2"

import SofiaProSemiBoldWoff from "../assets/fonts/sofia/SofiaProSemiBold.woff"
import SofiaProSemiBoldWoff2 from "../assets/fonts/sofia/SofiaProSemiBold.woff2"

import SofiaProMediumWoff from "../assets/fonts/sofia/SofiaProMedium.woff"
import SofiaProMediumWoff2 from "../assets/fonts/sofia/SofiaProMedium.woff2"

import SofiaProRegularWoff from "../assets/fonts/sofia/SofiaProRegular.woff"
import SofiaProRegularWoff2 from "../assets/fonts/sofia/SofiaProRegular.woff2"

import CooperLightWoff from "../assets/fonts/cooper/CooperBT-Light.woff"
import CooperLightWoff2 from "../assets/fonts/cooper/CooperBT-Light.woff2"

export const fontFace = (
  fontName,
  woff,
  woff2,
  ttf = null,
  fontWeight = "normal",
  fontStyle = "normal",
  display = "swap"
) => `
	@font-face {
		font-family: '${fontName}';
		src: ${
      ttf
        ? `url('${ttf}') format('truetype')`
        : `url('${woff2}') format('woff2'),
					url('${woff}') format('woff')`
    };
		font-weight: ${fontWeight};
		font-style: ${fontStyle};
		font-display: ${display};
	}
`
export const MaterialIcons = "Material Icons"
export const MaterialIconsFont = `
	@font-face {
		font-family: 'Material Icons';
		src: url('${MaterialIconsTTF}') format('truetype');
		font-weight: normal;
		font-style: normal;
		font-display: block;
	}
`

export const SofiaPro = "Sofia Pro"
export const SofiaProRegularFont = fontFace(
  SofiaPro,
  SofiaProRegularWoff,
  SofiaProRegularWoff2,
  null,
  "normal",
  "normal",
  "optional"
)
export const SofiaProMediumFont = fontFace(
  SofiaPro,
  SofiaProMediumWoff,
  SofiaProMediumWoff2,
  null,
  500,
  "normal",
  "optional"
)
export const SofiaProSemiBoldFont = fontFace(
  SofiaPro,
  SofiaProSemiBoldWoff,
  SofiaProSemiBoldWoff2,
  null,
  600,
  "normal",
  "optional"
)
/* TODO: SofiaProBold.woff/woff2 not in assets - using SemiBold as fallback. Add Bold files when available. */
export const SofiaProBoldFont = fontFace(
  SofiaPro,
  SofiaProSemiBoldWoff,
  SofiaProSemiBoldWoff2,
  null,
  700,
  "normal",
  "optional"
)

export const Cooper = "Cooper"
export const CooperLightFont = fontFace(
  Cooper,
  CooperLightWoff,
  CooperLightWoff2,
  null,
  "normal",
  "normal",
  "optional"
)

export const DMSans = "DM Sans"
const dmSansBase = (weight) => `
	@font-face {
		font-family: 'DM Sans';
		src: url('${DMSansLatinExtWoff2}') format('woff2');
		font-weight: ${weight};
		font-style: normal;
		font-display: swap;
		unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}
	@font-face {
		font-family: 'DM Sans';
		src: url('${DMSansWoff2}') format('woff2');
		font-weight: ${weight};
		font-style: normal;
		font-display: swap;
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}
`
export const DMSansRegularFont = dmSansBase(400)
export const DMSansSemiBoldFont = dmSansBase(600)
export const DMSansBoldFont = dmSansBase(700)
